<div class="thematic-card-layout thematic-card-layout--{{variant}}">
    <div class="thematic-card-header">
        <img class="thematic-card-icon" [src]="thematicStrategy.photoSmallUrl" alt="thematic strategy icon"/>

        <div class="thematic-card-header-values">

            <div
                class="name"
                [ngClass]="['name--' + variant]"
            >
                {{ thematicStrategy.name }}
            </div>
            <div
                class="yield"
                nz-tooltip
                autoCloseOnScroll
                nzTooltipOverlayClassName="lean"
                [nzTooltipTitle]="cardYield1YTooltip"
                [class.yield--negative]="thematicStrategy.yield1Y && thematicStrategy.yield1Y < 0"
                [class.yield--neutral]="!thematicStrategy.yield1Y"
                [nzTooltipVisible]="tooltipVisible()"
                (nzTooltipVisibleChange)="tooltipToggle($event)"
                (click)="tooltipToggle(!tooltipVisible())"
            >
                @if (thematicStrategy.yield1Y || thematicStrategy.yield1Y === 0) {
                    <span>{{ thematicStrategy.yield1Y > 0 ? '+' : '' }}</span>
                    <span>{{ thematicStrategy.yield1Y | percent:'1.0-2':'cs' }}</span>
                } @else {
                    <span>-</span>
                }

            </div>
            <ng-template #cardYield1YTooltip>
                <liberro-tooltip-content>
                    <div tooltipContent>
                        {{ 'thematicStrategies.cardYield1YTooltip' | translate }}
                    </div>
                </liberro-tooltip-content>
            </ng-template>
        </div>
    </div>

    <img
        class="thematic-card-image "
        [ngClass]="['thematic-card-image--' + variant]"
        [src]="thematicStrategy.photoLargeUrl"
        alt="thematic strategy image"
    />

    <span class="desc desc--{{variant}}" [ngClass]="['desc--' + variant]">
        {{ thematicStrategy.description }}
    </span>

    <div class="thematic-strategies-mobile-btn-container">
        <liberro-button
          size="small"
          widthType="width-100"
          [label]="'global.button.thematicStrategyDetail' | translate" (click)="selectStrategy()"
        ></liberro-button>
    </div>
    <div class="thematic-strategies-desktop-btn-container">
        <liberro-button
          size="small"
          widthType="width-100"
          [label]="'global.button.thematicStrategyDetail' | translate" (click)="selectStrategy()"
        ></liberro-button>
    </div>
</div>
